import React, { useEffect, useRef, useState } from "react";

interface TypeTimerProps {
  /**
   * @param seconds 最大秒数
   */
  seconds: number;
}

/**
 * @name Timer 计时器
 * @description 记录当前运行时间
 */
const Timer: React.FC<TypeTimerProps> = ({ seconds }) => {
  const ref = useRef(null);

  const [time, setTime] = useState(0);

  useEffect(() => {
    ref.current = setInterval(() => {
      setTime((num) => {
        const sec = num + 1;
        sec === seconds && clearInterval(ref.current);
        return sec;
      });
    }, 1000);
    return () => clearInterval(ref.current);
  }, []);

  const SECONDS = time % 60;

  return (
    <div
      style={{
        fontSize: 14,
        paddingTop: 2,
        marginRight: 10,
        fontFamily: "monospace",
        color: seconds - SECONDS <= 10 ? "#C21818" : "#586570",
      }}
    >
      {SECONDS < 10 ? `0${SECONDS}` : SECONDS}:{seconds}
    </div>
  );
};

export default Timer;
